import React from "react";
import { Formik } from "formik";
import { TextField, withStyles, Button, Typography } from "@material-ui/core";
import * as Yup from "yup";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    cancel: {
        width: "120px",
        marginTop: "10px",
        marginRight: "10px",
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
});

const TranslationForm = props => {
    const { classes, formSettings, initialValues, loading, handleSubmit, translations } = props;
    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    handleSubmit(values);
                    setSubmitting(false);

                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Key"
                                value={values.Key || ''}
                                onChange={handleChange}
                                error={!!(errors.Key && touched.Key && errors.Key)}
                                placeholder={translations['key'] || 'Key'}
                                label={translations['key'] || 'Key'}
                                onBlur={handleBlur}
                                margin={"dense"}
                                fullWidth={true}
                            />

                            <TextField
                                name="English"
                                value={values.English || ''}
                                onChange={handleChange}
                                error={!!(errors.English && touched.English && errors.English)}
                                placeholder={translations['english'] || 'English'}
                                label={translations['english'] || 'English'}
                                onBlur={handleBlur}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="German"
                                value={values.German || ''}
                                onChange={handleChange}
                                error={!!(errors.German && touched.German && errors.German)}
                                placeholder={translations['german'] || 'German'}
                                label={translations['german'] || 'German'}
                                onBlur={handleBlur}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            {formSettings.ButtonSubmit ? (
                                <Button
                                    className={classes.submit}
                                    variant="contained"
                                    color={formSettings.ButtonSubmit.Color}
                                    type="submit"
                                    disabled={isSubmitting || loading || !(isValid && dirty)}
                                >
                                    {formSettings.ButtonSubmit.Title}
                                </Button>
                            ) : null}
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(TranslationForm);
